import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import CloseIcon from "@material-ui/icons/Close";
import ButtonBB from "./buttons/ButtonBB";
import { useCTAButtonStyle } from "@View/style/components/tooltipStyles";

const useStyles = makeStyles(() => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: "#FFFFFF",
    padding: "28px 32px 24px",
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    width: "420px",
    maxWidth: "calc(100vw - 32px)",
    position: "relative",
    outline: "none",
    boxSizing: "border-box",
  },
  closeBtn: {
    position: "absolute",
    right: "20px",
    top: "20px",
    cursor: "pointer",
    color: "#A1ADBA",
    transition: "color 0.15s ease",
    "&:hover": {
      color: "#54606F",
    },
  },
  title: {
    margin: "0 0 10px",
    paddingRight: "28px",
    fontWeight: 600,
    fontSize: "19px",
    lineHeight: "26px",
    color: "#1A1E24",
  },
  text: {
    margin: 0,
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "22px",
    color: "#54606F",
  },
  actions: {
    display: "flex",
    gap: "12px",
    marginTop: "28px",
    marginLeft: "-32px",
    marginRight: "-32px",
    padding: "20px 32px 0",
    borderTop: "1px solid #E1E6F1",
  },
  confirmBtn: {
    flex: 1,
    borderRadius: "8px",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "17px",
    padding: "15px 20px",
    textTransform: "none",
  },
}));

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  text: string;
  confirmLabel: string;
  cancelLabel?: string;
}

const ConfirmModal = ({
  open,
  onClose,
  onConfirm,
  title,
  text,
  confirmLabel,
  cancelLabel = "Отмена",
}: ConfirmModalProps) => {
  const classes = useStyles();
  const ctaStyle = useCTAButtonStyle();

  return (
    <Modal
      open={open}
      onClose={onClose}
      className={classes.modal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 300 }}
    >
      <Fade in={open}>
        <div className={classes.paper}>
          <CloseIcon
            fontSize="small"
            className={classes.closeBtn}
            onClick={onClose}
          />

          <h2 className={classes.title}>{title}</h2>
          <p className={classes.text}>{text}</p>

          <div className={classes.actions}>
            <ButtonBB onClick={onClose} style={{ flex: 1 }}>
              {cancelLabel}
            </ButtonBB>
            <Button
              onClick={onConfirm}
              className={`${classes.confirmBtn} ${ctaStyle.default}`}
            >
              {confirmLabel}
            </Button>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default ConfirmModal;
